/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { compact, concat, flatten, isNil, keyBy } from 'lodash';
import * as constants from '../constants';
export const filterDocsByDesignations = (docs, docIdToRefMap, closingDesignations) => {
  const closingDesignationsSet = new Set(closingDesignations);
  return docs.filter(_ref => {
    let {
      _id
    } = _ref;
    const docRef = docIdToRefMap[_id];
    return closingDesignationsSet.has(docRef?.closingDesignation);
  });
};
export const filterAndGroupDocsByDesignations = (docs, docIdToRefMap, designations) => {
  const closingDesignationToDocsMap = {};
  designations.forEach(designation => {
    closingDesignationToDocsMap[designation] = [];
  });
  return docs.reduce((acc, doc) => {
    const closingDesignation = docIdToRefMap[doc._id]?.closingDesignation;
    if (closingDesignation && acc[closingDesignation]) {
      acc[closingDesignation].push(doc);
    }
    return acc;
  }, closingDesignationToDocsMap);
};
export const filterDocsByTypes = (docs, documentTypes) => {
  return docs.filter(doc => documentTypes.includes(doc.type));
};

// TODO: BRG-1111 update types for doc.source after updating lending client
export const filterDocsBySources = (docs, sourceTypes) => {
  return docs.filter(doc => sourceTypes.includes(doc.source));
};
export const filterDocsByUploader = (docs, principalId) => {
  return docs.filter(_ref2 => {
    let {
      uploadedBy
    } = _ref2;
    return uploadedBy === principalId;
  });
};
export const filterDocsByUploaders = (docs, principalIds) => {
  return docs.filter(_ref3 => {
    let {
      uploadedBy
    } = _ref3;
    if (uploadedBy) {
      return principalIds.has(uploadedBy);
    }
    return false;
  });
};
export const getDeletedDocumentReferencesFromAuditEvents = auditEvents => {
  const deletedDocumentReferences = auditEvents?.filter(_ref4 => {
    let {
      type,
      redrawCount
    } = _ref4;
    return type === 'CLOSING_DOCUMENTS_REMOVED' && redrawCount > 0;
  }).map(_ref5 => {
    let {
      meta
    } = _ref5;
    return !isNil(meta) && meta.documentReferences;
  });
  return flatten(deletedDocumentReferences);
};
export const getAllClosingDocumentReferences = (documentReferences, auditEvents) => {
  const deletedDocumentReferences = getDeletedDocumentReferencesFromAuditEvents(auditEvents);
  return compact(concat(documentReferences, deletedDocumentReferences));
};
export const convertDocumentReferencesToDocIdToRefMap = documentReferences => keyBy(documentReferences, _ref6 => {
  let {
    documentID
  } = _ref6;
  return documentID;
});
export const getAllReceivedDocuments = (me, loanDocuments) => loanDocuments.filter(_ref7 => {
  let {
    uploadedBy
  } = _ref7;
  return uploadedBy !== me.principalId;
});
export const getAllReceivedDocumentsForUsers = (principalIds, loanDocuments) => loanDocuments.filter(_ref8 => {
  let {
    uploadedBy
  } = _ref8;
  if (uploadedBy) {
    return !principalIds.has(uploadedBy);
  }
  return true;
});
export const getReceivedClosingDocuments = (me, loanDocuments) => getAllReceivedDocuments(me, loanDocuments).filter(_ref9 => {
  let {
    type
  } = _ref9;
  return type !== constants.ECloseDocumentTypes.PRELIMINARY_CLOSING_DOCUMENTS;
});
export const getReceivedClosingDocumentsFromAllReceivedDocs = allReceivedDocuments => allReceivedDocuments.filter(_ref10 => {
  let {
    type
  } = _ref10;
  return type !== constants.ECloseDocumentTypes.PRELIMINARY_CLOSING_DOCUMENTS;
});